import { render } from "./전화번호.vue?vue&type=template&id=a0fe4bca"
import script from "./전화번호.vue?vue&type=script&lang=js"
export * from "./전화번호.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__